import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'

// styles
import { styles } from './styles'

type PostCardProductProps = {}

export const PostCardProduct: FC<PostCardProductProps> = () => {
  const theme = useTheme()

  return (
    <div css={styles(theme).card.main}>
      <div css={styles(theme).card.lock.main}>
        <icons.Lock css={styles(theme).card.lock.icon} />
      </div>
    </div>
  )
}

PostCardProduct.propTypes = {}
